import { render, staticRenderFns } from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=template&id=e06e5ac4&scoped=true&"
import script from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js&"
export * from "./MusculoskeletalSymptomsSurveyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06e5ac4",
  null
  
)

export default component.exports